import React from 'react';

// eslint-disable-next-line react/display-name
export default () => {
    return (
        <div className="container">
            <h1 className="display-4" style={{ marginTop: 100 }}>
                <span className="text-danger">404</span> Page Not Found
            </h1>
            <p className="lead"> Sorry, the requested page does not exist</p>
        </div>
    );
};
